import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { IOption, Select } from '@destination/components';
import { ModelStatus } from '@/models/ModelStatus';

export default function SelectModelStatus() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation(undefined, { keyPrefix: 'browse' });

  const draftStatus: IOption = {
    label: t('select_status.draft'),
    value: ModelStatus.DRAFT
  };

  const releasedStatus: IOption = {
    label: t('select_status.released'),
    value: ModelStatus.RELEASED
  };

  const releasingStatus: IOption = {
    label: t('select_status.releasing'),
    value: ModelStatus.RELEASING
  };

  const statusTypes: IOption[] = [draftStatus, releasedStatus, releasingStatus];
  const selectedStatus = statusTypes.find(
    option =>
      option.value.toString().toLowerCase() === searchParams.get('status')
  );

  const handleChange = (option: IOption) => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('status') === option.value.toString().toLowerCase()) {
      params.delete('status');
      return setSearchParams(params);
    }

    params.set('status', option.value.toString().toLowerCase());
    setSearchParams(params);
  };

  return (
    <Select
      placeholder={t('select_status.placeholder')}
      options={statusTypes}
      selected={selectedStatus ?? null}
      onChange={handleChange}
    />
  );
}
